<template>
  <div class="authenticationPopup">
    <UserAuthenticationFlow @valid="handleLogin" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import UserAuthenticationFlow from "./UserAuthenticationFlow.vue";

@Component({
  components: {
    UserAuthenticationFlow,
  }
})
export default class EventAuthentication extends Vue {
  created(): void {
    document.cookie = "safari=iframe;path=/;max-age=86400";
  }

  handleLogin(v: boolean): void {
    if (v) {
      setTimeout(() => {
        window.close();
      }, 5000);
    }
  }
}
</script>

<style scoped>
.authenticationPopup {
  padding: 1em;
  overflow: hidden;
}
</style>
